// extracted by mini-css-extract-plugin
export default {"colourPreview":"ColourPreview_colourPreview__wZERO"};